import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Alert, Typography } from '@heroui/react';
import type { SalesTransaction } from '@/api/models';
import { JournalEntryLink } from '@/components/journalEntryLink';
import { getNodeTestIdProp } from '@/utils';
type TransactionDetailFooterProps = { transaction: SalesTransaction };
export const TransactionDetailFooter = ({
    transaction,
}: TransactionDetailFooterProps) => {
    const { t } = useTranslation('pages');
    return (
        <>
            {transaction.promoCode ? (
                <Typography
                    type="body-xs"
                    color="muted"
                    className="mt-3 flex items-center gap-2"
                    {...getNodeTestIdProp('transaction-detail-promo')}
                >
                    <Icon
                        aria-hidden
                        className="size-3.5"
                        icon="solar:tag-bold-duotone"
                        {...getNodeTestIdProp('transaction-detail-promo-icon')}
                    />
                    <span
                        {...getNodeTestIdProp('transaction-detail-promo-text')}
                    >
                        {t('sales.widgets.transactions.modal.promo')}:{' '}
                        {transaction.promoCode}
                    </span>
                </Typography>
            ) : null}
            {/* Where this receipt landed in the books. Renders
                                nothing for a sale recorded before operations
                                were wired to the ledger (BOS-119). */}
            <div
                className="mt-3"
                {...getNodeTestIdProp('transaction-detail-journal')}
            >
                <JournalEntryLink
                    date={transaction.transactionDate}
                    entryId={transaction.journalEntryId}
                    slot="transaction-detail"
                />
            </div>
            {transaction.refund?.note ? (
                <Alert
                    status="danger"
                    className="mt-3"
                    {...getNodeTestIdProp('transaction-detail-refund-note')}
                >
                    <Alert.Content>
                        <Alert.Title
                            {...getNodeTestIdProp(
                                'transaction-detail-refund-note-label',
                            )}
                        >
                            {t('sales.widgets.transactions.modal.refundNote')}
                        </Alert.Title>
                        <Alert.Description
                            {...getNodeTestIdProp(
                                'transaction-detail-refund-note-text',
                            )}
                        >
                            {transaction.refund.note}
                        </Alert.Description>
                    </Alert.Content>
                </Alert>
            ) : null}
        </>
    );
};
